import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { CalendarInputComponent } from '@navstation-portal/shared/ui/components';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-port-operations-timestamp',
  templateUrl: './port-operations-timestamp.component.html',
  styleUrl: './port-operations-timestamp.component.css',
  imports: [FormsModule, CalendarInputComponent],
})
export class PortOperationsTimestampComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'operational';
  sectionId = 'portOperationsTimestamp';
  events = injectDispatch(offshoreOperationalEvents);
  operationalStore = inject(OffshoreOperationalFormStore);
}
